import { Card, Typography } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../redux/hooks";
import { Policy } from "../../../../redux/reducers/types/commonTypes";
import { determineLowestPremium } from "../utils/riskUtils";
import PolicyIcon from "./PolicyIcon";

const { Text } = Typography;

export default function SlimPolicyCard({ policy }: { policy: Policy }) {
    const policyRisks = useAppSelector(
        (state) => state.risk.policyRisks?.[policy.id]
    );
    const risksPending = useAppSelector((state) => state.risk.getRisksPending);
    const lowestPremiumInPolicy = determineLowestPremium(policyRisks);

    return (
        <Link to={`/policy/${policy.id}`} style={{ textDecoration: "none" }}>
            <Card
                hoverable
                bordered
                style={{
                    borderRadius: "8px",
                    borderWidth: 1,
                    marginBottom: "12px",
                }}
                bodyStyle={{
                    padding: "16px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    <div style={{ 
                        flexShrink: 0, 
                        width: "48px", 
                        height: "48px", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        borderRadius: "8px", 
                        overflow: "hidden",
                        position: "relative"
                    }}>
                        <div style={{ 
                            position: "absolute",
                            transform: "scale(0.34)",
                            transformOrigin: "center center",
                            top: "50%",
                            left: "50%",
                            marginTop: "-70px",
                            marginLeft: "-60px"
                        }}>
                            <PolicyIcon type={policy.coverage_type} />
                        </div>
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <Text
                            strong
                            style={{
                                fontSize: "16px",
                                display: "block",
                                marginBottom: "4px",
                            }}
                        >
                            {policy.name}
                        </Text>
                        {policy.description && (
                            <Text
                                type="secondary"
                                style={{
                                    fontSize: "12px",
                                    display: "block",
                                    marginBottom: "4px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {policy.description}
                            </Text>
                        )}
                        {lowestPremiumInPolicy ? (
                            <Text type="secondary" style={{ fontSize: "14px" }}>
                                Starting at ${(lowestPremiumInPolicy / 100).toFixed(2)}/
                                {policy.premium_payment_frequency === 1
                                    ? "month"
                                    : `${policy.premium_payment_frequency} months`}
                            </Text>
                        ) : risksPending ? (
                            <Text type="secondary" style={{ fontSize: "14px" }}>
                                Loading...
                            </Text>
                        ) : (
                            <Text type="secondary" style={{ fontSize: "14px" }}>
                                No premiums yet
                            </Text>
                        )}
                    </div>
                </div>
            </Card>
        </Link>
    );
}

